var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB3C6C",
    d: "M3.806 20c-.519 0-.95-.176-1.292-.528-.343-.353-.514-.796-.514-1.33V5.858c0-.533.171-.976.514-1.328C2.857 4.176 3.287 4 3.806 4h16.388c.519 0 .95.176 1.293.53.342.351.513.794.513 1.327v12.286c0 .533-.171.976-.513 1.329-.343.352-.774.528-1.293.528H3.806ZM12 12.143l-8.889-6v12c0 .21.065.38.195.514s.296.2.5.2h16.388c.204 0 .37-.066.5-.2a.707.707 0 0 0 .195-.514v-12l-8.889 6Zm0-1.286 8.556-5.714H3.444L12 10.857ZM3.111 6.143v-1 13c0 .21.065.38.195.514s.296.2.5.2H3.11V6.143Z"
  })));
};
export default SvgMail;